import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./HowItWorks.css";

const steps = [
  {
    number: "01",
    title: "Escolha os sabores",
    text: "Defina os produtos com maior potencial para o perfil do seu restaurante.",
  },
  {
    number: "02",
    title: "Receba os produtos",
    text: "Pedido mínimo B2B, entrega rápida e produtos prontos para entrar na operação.",
  },
  {
    number: "03",
    title: "Comece a vender",
    text: "Monte sobremesas, combos ou sugestões no cardápio para aumentar o ticket médio.",
  },
];

function HowItWorks() {
  return (
    <section className="how section">
      <div className="container">
        <SectionTitle
          center
          eyebrow="Como funciona"
          title="Simples para começar. Fácil para vender."
          description="A estrutura foi pensada para reduzir fricção e mostrar que o restaurante consegue iniciar rapidamente."
        />

        <div className="how__grid">
          {steps.map((step) => (
            <div className="how__card" key={step.number}>
              <span>{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;